import React, { useState } from "react";
import BharatAraku from "../images/Bharat-Araku_NEW.png";
import Vanmaya from "../images/Van maya pouch.png";
import Timeless from "../images/Timeless-tin-.png";
import Signature from "../images/Signature-Qoffee-new.png";
import Brew from "../images/qoffee-brew-new-pouch.png";
import Stallion from "../images/Black-Stallion-tin.png";
import Qoffee from "../images/Qoffee-pouch-no-tm.png";
import Araku from "../images/araku-pouch-mockup-008.png";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ProductPage = () => {
  const [visibleCount, setVisibleCount] = useState(3); // Show 3 initially
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedWeight, setSelectedWeight] = useState("");
  const [quantity, setQuantity] = useState(1);

  const openModal = (product) => {
    setSelectedProduct(product);
    setSelectedWeight("");
    setQuantity(1);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  const allProducts = [
    {
      title: "Bharat Araku Beans",
      price: "₹1650.00",
      description: "100% Arabica AA Grade Beans",
      weights: ["1kg"],
      image: BharatAraku,
    },
    {
      title: "Van Maya Qoffee",
      price: "₹1200.00",
      description: "100% Arabica Green Beans",
      weights: ["1kg"],
      image: Vanmaya,
    },
    {
      title: "Araku Qoffee",
      price: "₹800.00",
      description: "100% Arabica Parchment",
      weights: ["1kg"],
      image: Araku,
    },
    {
      title: "Timeless Qoffee",
      price: "₹500.00",
      description: "A Premium Line of Flavoured Qoffee",
      weights: ["90gm", "45gm"],
      image: Timeless,
    },
    {
      title: "Signature  Qoffee",
      price: "₹1400.00",
      description: "Your Own Customized Blend",
      weights: ["500gm", "1kg"],
      image: Signature,
    },
    {
      title: "Black Stallion Qoffee",
      price: "₹400.00",
      description: "Perfect Blend of Qoffee",
      weights: ["90gm", "45gm"],
      image: Stallion,
    },
    {
      title: "Qoffee Brew",
      price: "₹1100.00",
      description: "Specially for Black Qoffee",
      weights: ["1gm", "200gm", "500gm", "1kg"],
      image: Brew,
    },
    {
      title: "Qoffee",
      price: "₹1250.00",
      description: "Rich and Bold Flavor",
      weights: ["1gm", "200gm", "500gm", "1kg"],
      image: Qoffee,
    },
    // Add more products if needed
  ];

  const styledproducts = ["Qoffee Brew", "Qoffee"];

  const loadMore = () => {
    setVisibleCount((prev) => prev + 5); // Show 3 more each time
  };

  const pageStyle = {
    fontFamily: "serif",
    backgroundColor: "rgb(232, 240, 238)",
    padding: "40px 40px 0 40px",
    flex: "1 1 30%",
    margin: "15px",
    boxSizing: "border-box",
    maxWidth: "35%",
    minWidth: "20%",
  };

  const imageStyle = {
    width: "100%",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    backgroundColor: "rgba(255, 248, 225, 0.7)",
  };

  const infoStyle = {
    color: "#421c10",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const titleStyle = {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  const priceStyle = {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#8b0000",
  };

  const descriptionStyle = {
    lineHeight: "1.6",
    margin: "0",
  };

  const buyButton = {
    backgroundColor: "rgb(192, 168, 117)",
    color: "white",
    border: "none",
    padding: "14px 32px",
    fontSize: "1rem",
    cursor: "pointer",
    borderRadius: "2px",
    letterSpacing: "2px",
    marginBottom: "20px",
  };

  const exploreButton = {
    backgroundColor: "rgb(192, 168, 117)",
    color: "white",
    border: "none",
    padding: "14px 32px",
    fontSize: "1rem",
    cursor: "pointer",
    borderRadius: "25px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease",
    fontWeight: "bold",
    marginTop: "40px",
  };

  const arrowStyle = {
    marginLeft: "10px",
    fontSize: "18px",
  };

  return (
    <>
      <Navbar />
      <div style={{ backgroundColor: "rgb(232, 240, 238)", padding: "20px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {allProducts.slice(0, visibleCount).map((product, index) => (
            <div key={index} style={pageStyle}>
              <div style={imageStyle}>
                <img
                  style={
                    styledproducts.includes(product.title)
                      ? { width: "80%", height: "280px", marginLeft: "10%" }
                      : { width: "100%", height: "280px" }
                  }
                  src={product.image}
                  alt={product.title}
                />

                <div style={infoStyle}>
                  <div style={titleStyle}>{product.title}</div>
                  <div style={priceStyle}>{product.price}</div>
                  <p style={descriptionStyle}>{product.description}</p>
                  <p>
                    <strong>Product weight:</strong> {product.weight}
                  </p>
                  {/* <a href={`https://wa.me/917399059999?text=I'm interested in buying ${encodeURIComponent(product.title)} for ${encodeURIComponent(product.price)}.`} */}
                  {/* // target="_blank" */}
                  {/* // rel="noopener noreferrer" */}
                  {/* // style={{ textDecoration: "none" }}> */}
                  {/* <button style={buyButton}>Buy Now</button></a> */}
                  <button style={buyButton} onClick={() => openModal(product)}>
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {visibleCount < allProducts.length && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button style={exploreButton} onClick={loadMore}>
              Explore more Products
              <span style={arrowStyle}>→</span>
            </button>
          </div>
        )}
      </div>
      {selectedProduct && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "30px",
              borderRadius: "10px",
              width: "90%",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h2>{selectedProduct.title}</h2>
            <p>Select Weight:</p>
            <select
              value={selectedWeight}
              onChange={(e) => setSelectedWeight(e.target.value)}
              style={{ padding: "10px", width: "100%", marginBottom: "15px" }}
            >
              <option value="">-- Select --</option>
              {selectedProduct.weights.map((weight, idx) => (
                <option key={idx} value={weight}>
                  {weight}
                </option>
              ))}
            </select>

            <p>Select Quantity:</p>
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              style={{ padding: "10px", width: "100%", marginBottom: "20px" }}
            />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button
                onClick={closeModal}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <a
                href={`https://wa.me/917399059999?text=Kindly process an order for ${selectedWeight} ${encodeURIComponent(
                  selectedProduct.title
                )}.%0AQuantity:  ${quantity}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeModal}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#4CAF50",
                  color: "#fff",
                  borderRadius: "5px",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Proceed
              </a>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default ProductPage;
